/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useState,
  useContext,
  useEffect,
  ChangeEvent,
  useCallback,
} from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import CasesAPI from 'api/CasesAPI';
import UsersAPI from 'api/UsersAPI';
import ContentError from 'components/Common/ContentError';
import CustomModuleHeaderLayout from 'components/Common/Layouts/CustomModuleHeaderLayout';
import { useSnackbar } from 'notistack';
import { Redirect, useHistory } from 'react-router-dom';

import DBModuleHeaderLayout from 'components/Common/Layouts/DBModuleHeaderLayout';
import DatabaseInfo from 'components/BiteDB/Components/DatabaseInfo';
import BiteDBAPI from 'api/BiteDBAPI';
import ReviewQueue from 'components/BiteDB/ReviewQueue';
import StatsRollUp from 'components/BiteDB/StatsRollUp';

interface TeamKeys {
  name: string;
  id: string;
}
const StatsRoll: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [autoTab, setAutoTab] = useState<string>('Dashboard');
  const [cardTab, setCardTab] = useState<string>('Card');
  const [userHasMonitor, setUserHasMonitor] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState<any>({});
  const [screeningCus, setScreeningCus] = useState({
    isLoading: true,
    data: '',
  });
  const [ownerEmail, setOwnerEmail] = useState('');
  const [autoID, setAutoID] = useState<number>(0);
  const [cases, setCases] = useState<{
    isLoaded: boolean;
    data: any[];
    error: string | undefined;
  }>({ isLoaded: false, data: [], error: undefined });
  const [cur_case, setCase] = useState<{
    isLoaded: boolean;
    error: string | undefined;
    data: any;
  }>({ isLoaded: false, error: undefined, data: {} });
  const [apiCases, setApiCases] = useState<{
    isLoaded: boolean;
    data: any[];
    error: string | undefined;
  }>({ isLoaded: false, data: [], error: undefined });
  const [docCases, setDocCases] = useState<{
    isLoaded: boolean;
    data: any[];
    error: string | undefined;
  }>({ isLoaded: false, data: [], error: undefined });
  const [database, setDatabase] = useState<any>([]);
  const [isDashboardLoading, setIsDashboardLoading] = useState(false);

  const requiredTiers = [
    'pro',
    'business',
    'enterprise',
    'database',
    'tariff database',
  ];

  const checkSubscription = () => {
    if (cur_user.quickcodeOnly) {
      setUserHasMonitor(true);
      return;
    }
    if (
      requiredTiers.some((role) =>
        cur_user.selected_team?.attributes?.tier.includes(role),
      )
    ) {
      setUserHasMonitor(true);
    }
  };

  useEffect(() => {
    if (cur_user.quickcodeOnly) {
      setUserHasMonitor(true);
      return;
    }
    checkSubscription();
  }, [cur_user.quickcodeOnly]);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const getOwner = async (id: string) => {
    const res = await UsersAPI.getUser(id);
    if (res?.success) {
      return res?.result.basics.email;
    }
    return '';
  };

  useEffect(() => {
    const fetchOwner = async () => {
      if (!selectedCase || !selectedCase._id) {
        return;
      } // Prevent running when empty

      CasesAPI.getCase(selectedCase._id)?.then(async (res: any) => {
        if (res?.success) {
          if (
            res.result.owner?.email !== cur_user.basics?.email &&
            !res.result.sharedWith.includes(cur_user.basics?.email) &&
            !res.result.sharedWith.includes(cur_user.basics?.id) &&
            !(res.result.createdBy === cur_user.basics?.id)
          ) {
            history.push('/');
          }

          setCase({ isLoaded: true, error: undefined, data: res.result });

          if (res.result.owner) {
            setOwnerEmail(res.result.owner?.email);
          } else {
            const email = await getOwner(res.result.createdBy);
            setOwnerEmail(email);
          }
        } else {
          const err_text = `Error loading case: ${res?.result}`;
          enqueueSnackbar(err_text, { variant: 'error' });
        }
      });
    };

    fetchOwner();
  }, [selectedCase]);

  const fetchDatabases = async (db_id: string) => {
    try {
      setIsDashboardLoading(true);
      const selected_team_id = cur_user?.selected_team?.id;
      if (!selected_team_id) {
        enqueueSnackbar('Please select a team', { variant: 'error' });
        return;
      }
      const response = await BiteDBAPI.getUserDatabases(db_id);
      if (response?.success) {
        setDatabase(response.result.data);
      } else {
        enqueueSnackbar(`Error fetching databases: ${response?.result}`, {
          variant: 'error',
        });
      }
    } catch (e) {
      console.error('Error fetching databases:', e);
      enqueueSnackbar('Failed to fetch databases', { variant: 'error' });
    } finally {
      setIsDashboardLoading(false);
    }
  };

  const helpContent = (
    <p className='module-header-tooltip-text'>
      Quickly search for high risk people, companies and products as well as
      cyber threat indicators. Filter by Lens for more accuracy
    </p>
  );

  return (
    <DBModuleHeaderLayout
      title='Databases'
      helpContent={helpContent}
      hubLabel='BITE DB'
      hubTo='/bite-db/entities'
    >
      <div>
        <StatsRollUp
          status_flag={
            props.location.state ? props.location.state.status_flag : ''
          }
        />
      </div>
    </DBModuleHeaderLayout>
  );
};

export default StatsRoll;
